import axios from 'axios';
import { ProductoModel } from '../../pages/catalogos/productos/models/ProductoModel';

const API_URL = process.env.REACT_APP_API;

export async function obtenerProductosService(): Promise<ProductoModel[]> {
  try {
    const response = await axios.get(`${API_URL}producto`);
    const data = response.data.doc.data;
    return data.rows ?? data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function obtenerProductoPorIdService(id: number): Promise<ProductoModel> {
  try {
    const response = await axios.get(`${API_URL}producto/${id}`);
    return response.data.doc.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function guardarProductoService(producto: ProductoModel): Promise<any> {
  try {
    const { id, nombre, tipo, unidad, costo_sugerido, util_proveedor } = producto;
    const payload = { nombre, tipo, unidad, costo_sugerido, util_proveedor: util_proveedor ?? null };
    if (id) {
      return await axios.put(`${API_URL}producto/${id}`, payload);
    } else {
      return await axios.post(`${API_URL}producto`, payload);
    }
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function eliminarProductoService(id: number): Promise<any> {
  try {
    return await axios.delete(`${API_URL}producto/${id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
}
